module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/disabled-selection/disabled-selection.component.css
// module id = ./src/app/examples/disabled-selection/disabled-selection.component.css
// module chunks = main